import { render, staticRenderFns } from "./Clouds.vue?vue&type=template&id=0538fc54&scoped=true&"
var script = {}
import style0 from "./Clouds.vue?vue&type=style&index=0&id=0538fc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0538fc54",
  null
  
)

export default component.exports